import React, { useState } from "react";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import LogoIn from "../img/logo_in.svg";
import LogoOr from "../img/logo_or.svg";
import LogoOut from "../img/logo_out.svg";
import { useInOrOutStore } from "../store/InOrOutStore";
import { useMediaQuery } from "usehooks-ts";

// Styled container for the logos
const StyledLogo = styled.div`
  margin-bottom: 3rem;
  display: flex;
  flex-flow: row;
  gap: 0;
`;

// Motion component for animated logo images
const FlyingLogoImg = styled(motion.img)<{ $activeOut?: boolean }>`
  position: absolute;
  transform: scale(1);
  top: 0%;
  opacity: 1;
  height: 56px;
  ${({ $activeOut }) =>
    $activeOut &&
    css`
      height: 80px;
      margin-top: -13px;
    `}
`;

export const InOrOutLogo = () => {
  const { activeGameState } = useInOrOutStore();

  const desktop = useMediaQuery("(min-width:1200px)");

  // Define animation variants for framer-motion
  const variants = {
    initial: { scale: 1, left: 0, top: "0%", opacity: 1 },
    fly: {
      scale: 4.65,
      left: "22%",
      top: "25%",
      opacity: 0,
      width: "auto",
      height: "auto",
      transition: { duration: 0.5, ease: "easeInOut" },
    },
    flyMobile: {
      scale: 3.3,
      left: "15%",
      top: "25%",
      opacity: 0,
      width: "auto",
      height: "auto",
      transition: { duration: 0.5, ease: "easeInOut" },
    },
    activeIn: {
      height: "80px",
      marginTop: "-13px",
      transition: { duration: 0.2, ease: "easeInOut" },
    },
    activeInInitial: {
      height: "56px",
      marginTop: 0,
    },
    activeOut: {
      height: "80px",
      marginTop: "-13px",
      transition: { duration: 0.2, ease: "easeInOut" },
    },
    activeOutInitial: {
      height: "56px",
      marginTop: 0,
    },
  };

  const activeIn = activeGameState?.choice === "IN";
  const activeOut = activeGameState?.choice === "OUT";

  return (
    <>
      <StyledLogo>
        <FlyingLogoImg
          src={LogoIn}
          initial="activeInInitial"
          animate={activeIn ? "activeIn" : "activeInInitial"}
          variants={variants}
        />
        <FlyingLogoImg
          src={LogoOr}
          style={{ left: activeIn ? "153px" : "106px" }}
        />
        <FlyingLogoImg
          src={LogoOut}
          style={{ left: activeIn ? "219px" : "172px" }}
          initial="activeOutInitial"
          animate={activeOut ? "activeOut" : "activeOutInitial"}
          variants={variants}
        />

        {/* Conditionally render animated logos only if activeGameState is present */}
        {activeIn && (
          <FlyingLogoImg
            src={LogoIn}
            initial="initial"
            animate={desktop ? "fly" : "flyMobile"}
            variants={variants}
          />
        )}
        {activeOut && (
          <FlyingLogoImg
            src={LogoOut}
            // style={{ paddingLeft: "172px" }}
            initial="initial"
            animate={desktop ? "fly" : "flyMobile"}
            variants={variants}
          />
        )}
      </StyledLogo>
    </>
  );
};
